// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"f48cae43","142":"0ea5f3a5","314":"ddf397d4","438":"fb0f7c12","453":"64632ac2","456":"32de193b","507":"b99c523b","525":"00b2dbe8","616":"fc304440","656":"d9f345be","714":"b0069fd9","763":"bed3d138","905":"7564164e","922":"2159933d","923":"52a115b8"}[chunkId] + ".chunk.js";
};